import * as React from 'react';
import { Link } from 'react-router-dom';
import { Container, Card, CardHeader, CardBody, Table } from 'reactstrap';
import BetterBreadcrumb from 'src/components/Common/BetterBreadCrumb';
import Breadcrumb from 'src/components/Common/Breadcrumb';
import { useGetTrnNoticeMasterListsQuery } from 'src/rtk/features/setup/trnNoticeMaster/setupTrnNoticeMaster';
import NoticeMasterTableRow from './NoticeMasterTableRow';

const TransactionNoticeLists = () => {
  const { data, error, isLoading, isError } = useGetTrnNoticeMasterListsQuery();

  const err: CustomError = error as CustomError;
  const noticeLists = data?.data || [];   

  let content = null;

  if (isLoading) {
    content = <div className="mt-3">Loading...</div>;
  }
  if (!isLoading && isError && error) {
    content = <div className="mt-3">{err.message}</div>;
  }
  if (!isLoading && !isError && noticeLists?.length > 0) {
    content = noticeLists.map((noticeList: any, index: any) => (
      <NoticeMasterTableRow
        notice={noticeList}
        index={index}
        key={noticeList.id}
      />
    ));
  } else {
    content = (
      <tr>
        <td colSpan={11}>
          <div className="text-center text-danger h6">No data available!</div>
        </td>
      </tr>
    );
  }
  return (
    <div className="page-content">
      <Container fluid>
        <BetterBreadcrumb
          breadcrumbItem={[{ link: '/notice', name: 'Add Notice' }]}
          title={'Notice List'}
        />
        <Card>
          <CardHeader className="d-flex justify-content-end">
            <Link className="btn btn-sm btn-primary" to="/notice">
              Add Notice
            </Link>
          </CardHeader>
          <CardBody>
            <div className="table-responsive">
              <Table className="table mb-0">
                <thead>
                  <tr>
                    <th>Sl. </th>
                    <th>Notice Template</th>
                    <th>Notice No</th>
                    <th>Notice Subject</th>
                    <th>Notice Type</th>
                    <th>Department</th>
                    {/* <th>Notice Header</th> */}
                    <th>Notice Body</th>
                    {/* <th>Notice Footer</th> */}
                    <th>Notice Date</th>
                    <th>Status</th>                                                                                                                         
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>{content}</tbody>
              </Table>
            </div>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default TransactionNoticeLists;
